import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=8734%3A20622
 *
 * @param {SvgIconProps} props - svg props
 */
export const AccessIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path fillRule='evenodd' clipRule='evenodd' d='M13.7697 11.7166C13.6611 11.8244 13.762 12.0758 13.762 12.0758L13.7387 20.8822L12.1863 24C10.925 24 9.92756 21.7046 9.92756 21.7046L10.7038 19.9082L9.90427 19.0619L10.6843 18.2635L10.6766 17.4687L9.92756 16.6667L10.7115 15.9681L9.9392 14.519L9.88875 12.0758L9.86546 11.6367C7.71151 10.7425 6 8.57485 6 6.03593C6 2.70259 8.62743 0 11.868 0C15.1125 0 18 2.63473 18 5.97206C18 8.77844 15.4541 11.4411 13.7697 11.7166ZM12.2252 20.4069C12.2252 20.6304 12.3999 20.8061 12.6133 20.8061C12.8268 20.8061 13.0014 20.6304 13.0014 20.4069V12.3909C13.0014 12.1713 12.8268 11.9917 12.6133 11.9917C12.3999 11.9917 12.2252 12.1713 12.2252 12.3909V20.4069ZM11.9149 1.59277C10.673 1.59277 9.66786 2.14766 9.66786 2.55485C9.66786 2.95804 10.673 3.21752 11.9149 3.21752C13.1569 3.21752 14.162 2.95804 14.162 2.55485C14.162 2.14766 13.1569 1.59277 11.9149 1.59277Z' fill={color}/>
        </SvgIcon>
    )
}

export default AccessIcon
